import standardButtonReducer from "../../../helpers/standard-button-reducer";

const reducer = standardButtonReducer("EVENT_FETCH");

export default reducer;
